import { deleteCookie } from 'cookies-next';

export function signOut() {
  deleteCookie('@event-monitor-web:token-1.0.1', { path: '/' });
  deleteCookie('@event-monitor-web:refreshToken-1.0.1', { path: '/' });
  deleteCookie('@event-monitor-web:user-1.0.1', { path: '/' });

  window.location.href = '/';
}
